module.exports = __webpack_public_path__ + "static/media/banner.b5e8c7de.jpg";